export const visibleByConfig = (isVisibleByConfig, isVisibleByRole, condition) =>
  isVisibleByRole || (isVisibleByConfig && condition)
